(function($){

  // Any modal with id starting with "find-size-"
  var $root = $('[id^="find-size-"], [id^="find-size-light-"]');

  if (!$root.length) return;

  /* -------------------------------
      CLICK: select bra size
  -------------------------------- */
  $root.on('click', '.size-box', function(){
    var $wrap = $(this).closest('.tag-list');
    $wrap.find('.size-box').removeClass('active');
    $(this).addClass('active');
  });

  /* -------------------------------
      FIT GUIDE DATA
  -------------------------------- */
  var topsizes = {
    usa: { XS:'34AA,32AA,32A,30A,30B', S:'36AA,34A,32B', M:'36A,34B,32C', L:'36B,34C,32D', XL:'36C,34D,36D,38C,32DD,34DD' },
    uk : { XS:'34A,32A,32B,30B,30C', S:'36A,34B,32C', M:'36B,34C,32D', L:'36C,34D,32DD', XL:'36D,34DD,36DD,38D,32E,34E' },
    au : { XS:'12AA,10AA,10A,8A,8B', S:'14AA,12A,10B', M:'14A,12B,10C', L:'14B,12C,10D', XL:'14C,12D,14D,16C,10DD,12DD' },
    eu : { XS:'75A,70A,70B,65B,65C', S:'80A,75B,70C', M:'80B,75C,70D', L:'80C,75D,70E', XL:'80D,75E,80E,85D,70F,75F' },
    be : { XS:'90A,85A,85B,80B,80C', S:'95A,90B,85C', M:'95B,90C,85D', L:'95C,90D,85E', XL:'95D,90E,95E,125D,85F,90F' },
    it : { XS:'2A,1A,1B,0B,0C',       S:'3A,2B,1C',     M:'3B,2C,1D',     L:'3C,2D,1E',     XL:'3D,2E,3E,4D,1F,2F' }
  };

  var onepiece = {
    usa:{ 'XS,XS,S,M,M':'34AA,32AA,32A,30A,30B', 'S,S,M,M,L':'36AA,34A,32B', 'S,M,M,M,L':'36A,34B,32C', 'M,M,L,L,L':'36B,34C,32D', 'L,L,L,XL,XL':'36C,34D,36D,38C,32DD,34DD' },
    uk :{ 'XS,XS,S,M,M':'34A,32A,32B,30B,30C',  'S,S,M,M,L':'36A,34B,32C',  'S,M,M,M,L':'36B,34C,32D',  'M,M,L,L,L':'36C,34D,32DD', 'L,L,L,XL,XL':'36D,34DD,36DD,38D,32E,34E' },
    au :{ 'XS,XS,S,M,M':'12AA,10AA,10A,8A,8B',  'S,S,M,M,L':'14AA,12A,10B',  'S,M,M,M,L':'14A,12B,10C',  'M,M,L,L,L':'14B,12C,10D',  'L,L,L,XL,XL':'14C,12D,14D,16C,10DD,12DD' },
    eu :{ 'XS,XS,S,M,M':'75A,70A,70B,65B,65C',  'S,S,M,M,L':'80A,75B,70C',   'S,M,M,M,L':'80B,75C,70D',   'M,M,L,L,L':'80C,75D,70E',   'L,L,L,XL,XL':'80D,75E,80E,85D,70F,75F' }
  };

  var hip = {
    usa:'34” – 36”,36” – 38”,38” – 40”,40” – 42”,42” – 44”',
    uk :'86 – 91 cm,91 – 97 cm,97 – 102 cm,102 – 107 cm,107 – 112 cm',
    au :'86 – 91 cm,91 – 97 cm,97 – 102 cm,102 – 107 cm,107 – 112 cm',
    eu :'86 – 91 cm,91 – 97 cm,97 – 102 cm,102 – 107 cm,107 – 112 cm',
    be :'86 – 91 cm,91 – 97 cm,97 – 102 cm,102 – 107 cm,107 – 112 cm',
    it :'86 – 91 cm,91 – 97 cm,97 – 102 cm,102 – 107 cm,107 – 112 cm'
  };

  var bottomsizes = {
    in:{ waist:{XS:'24” – 26”', S:'26” – 28”', M:'28” – 30”', L:'30” – 32”', XL:'32” – 34”'}, 
         hip:{XS:'34” – 36”', S:'36” – 38”', M:'38” – 40”', L:'40” – 42”', XL:'42” – 44”'}
    },
    cm:{ waist:{XS:'61 – 66 cm', S:'66 – 71 cm', M:'71 – 76 cm', L:'76 – 81 cm', XL:'81 – 86 cm'},
         hip:{XS:'86 – 91 cm', S:'91 – 97 cm', M:'97 – 102 cm', L:'102 – 107 cm', XL:'107 – 112 cm'}
    }
  };

  /* -------------------------------
      FIND MY SIZE BUTTON
  -------------------------------- */
  $root.on('click', '.btn-find-size', function(){

    var type      = $(this).data('type'); 
    var container = $(this).closest('.container');
    var findSize  = '';

    if (type === 'top') {
      var country = container.find('.find-size-country').val();
      var bra     = container.find('.size-box.active').text();
      if (!bra){ alert("Select bra size!"); return; }

      $.each(topsizes[country], function(size, list){
        if (list.includes(bra)) findSize = size;
      });
    }

    if (type === 'bottom') {
      var sizing = container.find('.find-size-sizing').val();
      var w = container.find('.find-size-waist').val();
      var h = container.find('.find-size-hip').val();
      var order = {XS:1, S:2, M:3, L:4, XL:5};
      findSize = order[w] > order[h] ? w : h;
    }

    if (type === 'onepiece') {
      var country = container.find('.find-size-country').val();
      var bra     = container.find('.size-box.active').text();
      var hipIdx  = container.find('.find-size-hip').val();
      if (!bra){ alert("Select bra size!"); return; }

      $.each(onepiece[country], function(sizeStr, list){
        if (list.includes(bra)){
          findSize = sizeStr.split(',')[hipIdx];
        }
      });
    }

    if (findSize){
      container.find('.find-size-content').hide();
      container.find('.find-size-result .size-result').text(findSize);
      container.find('.find-size-result').show();
    }

  });

  /* -----------------------------------
     START OVER
  ----------------------------------- */
  $root.on('click', '.btn-start-over', function(){
    var container = $(this).closest('.container');
    container.find('.find-size-result').hide();
    container.find('.find-size-content').show();
  });

  /* -----------------------------------
     COUNTRY CHANGE — rebuild bra list
  ----------------------------------- */
  $root.on('change', '.find-size-country', function(){

    var container = $(this).closest('.container');
    var country   = $(this).val();

    var $list = container.find('.tag-list');
    $list.empty();

    // all bras in sorted order
    var bras = [];
    $.each(topsizes[country], function(size, list){
      bras = bras.concat(list.split(','));
    });

    bras.sort();

    bras.forEach(function(item){
      $list.append('<span class="size-box">'+item+'</span>');
    });

    var $hip = container.find('.find-size-hip');
    if ($hip.length && hip[country]){
      $hip.empty();
      hip[country].split(',').forEach(function(h, i){
        $hip.append('<option value="'+i+'">'+h+'</option>');
      });
    }

  });

  /* -----------------------------------
     UNIT CHANGE (bottoms)
  ----------------------------------- */
  $root.on('change', '.find-size-sizing', function(){

    var container = $(this).closest('.container');
    var sizing    = $(this).val();

    var $waist = container.find('.find-size-waist');
    var $hip   = container.find('.find-size-hip');

    $waist.empty();
    $.each(bottomsizes[sizing]['waist'], function(size, val){
      $waist.append('<option value="'+size+'">'+val+'</option>');
    });

    $hip.empty();
    $.each(bottomsizes[sizing]['hip'], function(size, val){
      $hip.append('<option value="'+size+'">'+val+'</option>');
    });

  });

})(jQuery);

let overlay = document.querySelectorAll('.overlay');
console.log(overlay)

let topBtn = document.querySelector('[data-top-btn]');
if (topBtn) {
  topBtn.addEventListener('click', () => {
    let top = document.querySelector('#find-size-top');
    if (overlay[0]) overlay[0].classList.add('active');
  });
}
let topClose = document.querySelectorAll('[data-top-close]');
if (topClose.length > 0) {
topClose.forEach(topBtn => {
  topBtn.addEventListener('click', () => {
    topBtn.closest('.overlay').classList.remove('active');
  });
  })

}
let btnBottom = document.querySelector('[data-bottom-btn]');
 if (btnBottom) { 
  btnBottom.addEventListener('click', (e) => {
     let bottom = document.querySelector('#find-size-bottom');
      
       if (overlay[1]) overlay[1].classList.add('active'); 
      }); 
  }

  let btnBottom2 = document.querySelector('[data-bottom-btn2]');
 if (btnBottom2) { 
  btnBottom2.addEventListener('click', (e) => {
     let bottom2= document.querySelector('#find-size-bottom');
      e.preventDefault(); 
      e.stopPropagation();
       if (overlay[2]) overlay[2].classList.add('active'); 
      }); 
  }

document.addEventListener('DOMContentLoaded', () => {

  /* ================================
        OPEN BOTTOM POPUP
  =================================*/
  const btnBottom = document.querySelector('[data-bottom-btn]');
  if (btnBottom) {
    btnBottom.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const overlay = document.querySelector('.overlay[data-type="bottom"]');
      if (overlay) overlay.classList.add('active');
    });
  }


  /* ================================
        CLOSE BUTTON
  =================================*/
  setTimeout(() => {
    const closeButtons = document.querySelectorAll('[data-bottom-close]');

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const overlay = btn.closest('.overlay');
        if (overlay) overlay.classList.remove('active');
      });
    });

  }, 500);

  /* ================================
        PREVENT POPUP FROM CLOSING 
        WHEN CLICKING INSIDE CONTENT
  =================================*/
  document.querySelectorAll('.overlay .cst_find_size').forEach((modal) => {
    modal.addEventListener('click', (e) => {
      e.stopPropagation();   // <— stops closing on inner click
    });
  });

  /* ================================
        CLICKING OUTSIDE (BACKGROUND)
        SHOULD CLOSE POPUP
  =================================*/
  document.querySelectorAll('.overlay').forEach((overlay) => {
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
    });
  });

  let urlItems = document.querySelectorAll('.link_url');

if (urlItems.length > 0) {
  urlItems.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault(); // stop default link behavior
      let link = item.getAttribute('href');

      if (link) {
        window.location.href = link;
      }
    });
  });
}
let topBtn2 = document.querySelector('[data-top-btn2]');
if (topBtn2) {
  topBtn2.addEventListener('click', () => {
    let top2 = document.querySelector('#find-size-top');
    if (overlay[0]) overlay[0].classList.add('active');
  });
}
});


document.addEventListener('DOMContentLoaded',()=>{
function updateVariantImages() {
  const allchecked = document.querySelectorAll(
    ".style-top-info input[type='radio']:checked"
  );
  const allImages = document.querySelectorAll(".product__thumb-item");

  const allVal = [...allchecked].map(rad => String(rad.dataset.nameValue));

  allImages.forEach(img => {
    const variantId = String(img.getAttribute("data-variant-id"));

    if (allVal.includes(variantId)) {
      img.classList.add("isShow");
    } else {
      img.classList.remove("isShow");
    }
  });
}

/* Run once on page load */
updateVariantImages();

/* Run on variant change */
document
  .querySelectorAll(".style-top-info input[type='radio']")
  .forEach(radio => {
    radio.addEventListener("change", updateVariantImages);
  });

})

